import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import IconButton from '@mui/material/IconButton';
import * as React from 'react';
import { ExpandButtonProps } from './types';

export const ExpandButton: React.FC<ExpandButtonProps> = ({ isExpanded, setIsExpanded }) => (
  <IconButton title="Expand" onClick={() => setIsExpanded((prev) => !prev)} size="large">
    {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
  </IconButton>
);
